import icon from 'vue-svgicon';

icon.register({
    'bold/layout-module': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<rect pid="0" x=".25" y=".247" width="6.5" height="6.5" rx="1.5" ry="1.5"/><rect pid="1" x=".25" y="8.747" width="6.5" height="6.5" rx="1.5" ry="1.5"/><rect pid="2" x=".25" y="17.247" width="6.5" height="6.5" rx="1.5" ry="1.5"/><rect pid="3" x="8.75" y=".247" width="6.5" height="6.5" rx="1.5" ry="1.5"/><rect pid="4" x="8.75" y="8.747" width="6.5" height="6.5" rx="1.5" ry="1.5"/><rect pid="5" x="8.75" y="17.247" width="6.5" height="6.5" rx="1.5" ry="1.5"/><rect pid="6" x="17.25" y=".247" width="6.5" height="6.5" rx="1.5" ry="1.5"/><rect pid="7" x="17.25" y="8.747" width="6.5" height="6.5" rx="1.5" ry="1.5"/><rect pid="8" x="17.25" y="17.247" width="6.5" height="6.5" rx="1.5" ry="1.5"/>`,
    },
});
